import { skipToken } from '@reduxjs/toolkit/query'
import { useGetAllApplicationsByClientFilterByTagsQuery } from 'core/api/application'
import Loader from 'core/components/common/Loader'
import { UserContext } from 'core/contexts/UserContext'
import { useMyPermissions } from 'core/hooks/useMyPermissions'
import { IApplication } from 'core/interfaces/Application'
import { UseKeycloakService } from 'core/packages/KeycloakProvider'
import { ApplicationCardListWrapper } from 'lauria/components/dashboard/ApplicationCardListWrapper'
import { ApplicationFilters } from 'lauria/components/dashboard/ApplicationFilters'
import { FilterModal } from 'lauria/components/dashboard/FilterModal'
import { MobileMenu } from 'lauria/components/dashboard/MobileMenu'
import { UserCard } from 'lauria/components/layout/UserCard'
import { UserCardMobile } from 'lauria/components/layout/UserCardMobile'
import { useDashboardFilters } from 'lauria/hooks/useDashboardFilters'
import { useContext, useEffect, useState } from 'react'

export const Dashboard = () => {
  const [applications, setApplications] = useState<IApplication[]>([])
  const [filtersApplied, setFiltersApplied] = useState(false)

  const [isAppLoading, setIsAppLoading] = useState(false)
  const [openFilter, setOpenFilter] = useState(false)

  const { user: currentUser, businessStatus } = useContext(UserContext)

  const { canAccessDashboard } = useMyPermissions()

  // Use custom hook for persistent filters
  const { service, setService, selectedTags, setSelectedTags } =
    useDashboardFilters(currentUser?.idClient ?? null)

  const idClient = currentUser?.idClient
  const { data, isLoading, isFetching } =
    useGetAllApplicationsByClientFilterByTagsQuery(
      idClient
        ? {
            idClient,
            services: service ? [parseInt(service)] : [],
            tags: selectedTags.map((tag) => tag.id),
          }
        : skipToken
    )

  const accessDashboard = canAccessDashboard

  const openFilterModal = () => {
    setOpenFilter(true)
  }

  useEffect(() => {
    setIsAppLoading(isFetching)

    if (!isFetching && data) {
      setApplications(data)
    }
  }, [isFetching, data])

  const keycloak = UseKeycloakService()

  if (businessStatus === 'idle' || businessStatus === 'loading') {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Loader pageCenter />
      </div>
    )
  }

  if (businessStatus === 'error') {
    return <div>Erreur lors du chargement des données utilisateur.</div>
  }

  if (isLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Loader pageCenter />
      </div>
    )
  }

  return (
    applications && (
      <div className="dashboard-wrapper">
        <div className="sidebar dashboard-side">
          <UserCard username={keycloak.getName()} />
          {accessDashboard && (
            <ApplicationFilters
              setSelectedTags={setSelectedTags}
              selectedTags={selectedTags}
              service={service}
              setService={setService}
              setFiltersApplied={setFiltersApplied}
            />
          )}
        </div>
        <UserCardMobile username={keycloak.getName()} />
        <ApplicationCardListWrapper
          applications={applications}
          isLoading={isAppLoading}
          filtersApplied={filtersApplied}
          accessDashboard={accessDashboard}
        />
        <MobileMenu
          openFilterModal={openFilterModal}
          displayAddButton={applications.length > 0 && accessDashboard}
        />
        <FilterModal
          open={openFilter}
          setOpen={setOpenFilter}
          setApplications={setApplications}
        />
      </div>
    )
  )
}
